import '../../../../styles/tokens.stylex';
import { spacing } from '../../../../styles/tokens.stylex';
import { Form as BaseForm } from '@base-ui/react/form';
import * as stylex from '@stylexjs/stylex';
import { Ref } from 'react';
import { typography } from '../../../../styles/typography';
import { useRender, UseRenderRenderProp } from '@base-ui/react/use-render';
type FormProps = {
  children: React.ReactNode;
  styles?: stylex.StyleXStyles;
} & BaseForm.Props;
export type FormPresentationalProps<T = HTMLDivElement> = React.HTMLAttributes<T> & {
  children?: React.ReactNode;
  styles?: stylex.StyleXStyles;
  ref?: Ref<T>;
  render?: UseRenderRenderProp<Record<string, unknown>>;
};
export function Root({
  children,
  styles,
  ...props
}: FormProps) {
  return <BaseForm {...stylex.props(sx.form, styles)} {...props}>
      {children}
    </BaseForm>;
}
export function Title({
  children,
  styles
}: FormPresentationalProps) {
  return <h2 {...stylex.props(typography.heading2, styles)}>{children}</h2>;
}
export function Section({
  children,
  styles,
  render,
  ...props
}: FormPresentationalProps) {
  return useRender({
    defaultTagName: 'div',
    render,
    props: {
      ...stylex.props(sx.section, styles),
      children,
      ...props
    }
  });
}
export function SectionHeading({
  children,
  styles
}: FormPresentationalProps) {
  return <h2 {...stylex.props(typography.heading3, sx.sectionHeading, styles)}>
      {children}
    </h2>;
}
export function FieldWrapper({
  children,
  styles
}: FormPresentationalProps) {
  return <div {...stylex.props(sx.fieldWrapper, styles)}>{children}</div>;
}
const sx = {
  form: {
    kOIVth: "x3ybb33",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    $$css: true
  },
  section: {
    kOIVth: "xej1lkh",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    $$css: true
  },
  sectionHeading: {
    k1K539: "x19de1a6",
    $$css: true
  },
  fieldWrapper: {
    kOIVth: "x3ybb33",
    k1C7PZ: "xtj86w2",
    kanfag: "x1xzsks8",
    k9g6sI: "x12h1iku",
    k1xSpc: "xrvj5dj",
    kumcoG: "xuzcw8z",
    $$css: true
  }
};
export const Form = {
  Root,
  Title,
  Section,
  SectionHeading,
  FieldWrapper
};